App.factory('documentationService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function DocumentationService() {
        this.dataDocumentation = function(criteria) {
            return baseService.post(Config.API_URL + '/orders/dataPage', criteria).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };
    }
    return new DocumentationService();
}]);